import { Grid, type SxProps, Typography } from '@mui/material';
import { useState } from 'react';

const ExpertoBayerCatalogAction = ({
    src,
    title,
    description,
    onClick,
    sx,
}: {
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    src: string;
    description?: string;
    title: string;
    sx: SxProps;
}) => {
    const [hover, setHover] = useState(false);

    const handleMouseEnter = () => setHover(true);
    const handleMouseLeave = () => setHover(false);

    return (
        <Grid
            container
            sx={{ position: 'relative', cursor: 'pointer', ...sx }}
            flexWrap={'nowrap'}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={(e) => {
                onClick(e);
                setHover(false);
            }}
        >
            <Grid item>
                <img
                    src={src}
                    style={{
                        width: 80,
                        zIndex: 4,
                        position: 'relative',
                        left: hover ? 75 : -50,
                        transform: hover ? 'translateX(0)' : 'translateX(50px)',
                        transition: 'opacity 0.4s ease, transform 0.4s ease',
                    }}
                    alt='ask an expert logo'
                />
            </Grid>

            <Grid
                item
                container
                direction={'column'}
                justifyContent={'center'}
                sx={{
                    pl: 11,
                    pr: 2,
                    mt: 0.25,
                    mb: 1.5,
                    boxShadow: 4,
                    ':active': {
                        boxShadow: 5,
                    },
                    borderRadius: 10,
                    background: 'white',
                    zIndex: 3,
                    maxHeight: '80px',
                    position: hover ? 'relative' : 'absolute',
                    left: hover ? '0' : 150,
                    opacity: hover ? 1 : 0,
                    transform: hover ? 'translateX(0)' : 'translateX(20px)',
                    transition: 'opacity 0.7s ease, transform 0.7s ease',
                }}
            >
                <Grid item>
                    <Typography color='primary' sx={{ fontWeight: 600, fontSize: 16 }}>
                        {title}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ fontSize: 12 }} color='primary'>
                        {description}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ExpertoBayerCatalogAction;
